<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="页面名称">
                  <el-input  style="width: 200px" v-model="queryForm.pageName"></el-input>
              </el-form-item>
              <el-form-item label="页面链接">
                  <el-input  style="width: 200px" v-model="queryForm.pageLink"></el-input>
              </el-form-item>
              <el-form-item label="页面类型">
                  <!-- <el-input  v-model="queryForm.pageType"></el-input> -->
                  <el-select placeholder="请选择类型"  clearable style="width: 200px"
                      size="small" v-model="queryForm.pageType">
                      <el-option v-for='(item, index) in adsLinkList' :key='index' :label="item.value" :value="item.key"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="排序">
                  <el-input  style="width: 200px" v-model="queryForm.sort"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getMppAppPageList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addMppAppPage"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editMppAppPage(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteMppAppPage(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshMppAppPageList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="mppAppPageList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="pageName"
        label="页面名称"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="pageLink"
        label="页面链接"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="pageType"
        label="页面类型"
        min-width="180"
      > 
        <template slot-scope="scope">
          {{getadslinks(scope.row.pageType)}}
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sort"
        label="排序"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        min-width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkMppAppPage(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editMppAppPage(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteMppAppPage(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="mppAppPageStates[mppAppPageState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="mppAppPage"
          ref="mppAppPageForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="页面名称"
            prop="pageName"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="mppAppPage.pageName"
              :disabled="mppAppPageState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="页面链接"
            prop="pageLink"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="mppAppPage.pageLink"
              :disabled="mppAppPageState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="页面类型"
            prop="pageType"
          >
            <!-- <el-input
              size="small"
              v-model="mppAppPage.pageType"
              :disabled="mppAppPageState == 'check'"
            ></el-input> -->
            <el-select placeholder="请选择类型"  clearable style="width: 200px"
                size="small" v-model="mppAppPage.pageType" :disabled="mppAppPageState == 'check'">
                <el-option v-for='(item, index) in adsLinkList' :key='index' :label="item.value" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="排序"
            prop="sort"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="mppAppPage.sort"
              :disabled="mppAppPageState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="mppAppPageState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetMppAppPageList();
                    this.getMppAppPageList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetMppAppPageList();
                    this.getMppAppPageList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     pageName: '', //页面名称
                     pageLink: '', //页面链接
                     pageType: '', //页面类型
                     sort: '', //排序
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                mppAppPageState: 'add',
                mppAppPageStates: {
                    add: '新建页面地址',
                    check: '查看页面地址',
                    edit: '修改页面地址'
                },
                multipleSelection: [],
                mppAppPageList: [],
                mppAppPage: {
                    pageName: '', //页面名称
                    pageLink: '', //页面链接
                    pageType: '', //页面类型
                    sort: '', //排序
                    createUserId: '', //
                },
                btnLoading: false,
                adsLinkList:[],
                rules: {
                    pageName: [{ required: true, message: '页面名称不能为空', trigger: 'blur' }],
                    pageLink: [{ required: true, message: '页面链接不能为空', trigger: 'blur' }],
                    pageType: [{ required: true, message: '页面类型不能为空', trigger: 'blur' }],
                    sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                    createTime: [{ required: true, message: '不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getMppAppPageList();
            this.getCmsAdsLists()
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetMppAppPageList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.mppAppPageList = [];
            },
            resetDialog() {
                this.mppAppPageState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      pageName: '', //页面名称
                      pageLink: '', //页面链接
                      pageType: '', //页面类型
                      sort: '', //排序
                };
                this.getMppAppPageList();
            },
            getCmsAdsLists() {
              // 链接类型
              get('/mpp/utils/getEnum', {
              enumType: 'app_page_type_shop',
              }).then((res) => {
                  if (res.success) {
                      // console.log(res.enumList)
                      this.adsLinkList = res.enumList
                  }
              })
            },
            // 链接类型
            getadslinks(key){
                for (const iterator of this.adsLinkList) {
                    if(iterator.key == key){
                        return iterator.value
                    }
                }
            },
            closeDialog() {
                this.showDialog = false
                this.mppAppPage = {
                      pageName: '', //页面名称
                      pageLink: '', //页面链接
                      pageType: '', //页面类型
                      sort: '', //排序
                      createTime: '', //
                };
            },
            submitForm() {
                if (this.mppAppPageState == 'add') {
                    this.$refs.mppAppPageForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/mpp/apppage/add`,{ ...this.mppAppPage }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetMppAppPageList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.mppAppPageState == 'edit') {
                    this.$refs.mppAppPageForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/mpp/apppage/edit`,{ ...this.mppAppPage }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetMppAppPageList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addMppAppPage() {
                this.showDialog = true;
                this.mppAppPageState = 'add';
            },
            checkMppAppPage(mppAppPageId) {
                console.log(mppAppPageId);
                this.currentMppAppPageId = mppAppPageId;

                this.getMppAppPageById();
                this.showDialog = true;
                this.mppAppPageState = 'check';
            },
            editMppAppPage(mppAppPageId) {
                console.log('mppAppPage', mppAppPageId);
                if (mppAppPageId) {
                    this.currentMppAppPageId = mppAppPageId;
                    this.getMppAppPageById();
                } else {
                    this.mppAppPage = { ...this.mppAppPage, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.mppAppPageState = 'edit';
            },
            deleteMppAppPage(mppAppPageId) {
                let ids = '';
                if (mppAppPageId) {
                    ids = mppAppPageId;
                } else {
                    ids = this.multipleSelection.map((mppAppPage) => mppAppPage.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/mpp/apppage/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppAppPageList();
                                this.getMppAppPageList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshMppAppPageList() {
                this.resetMppAppPageList();
                this.getMppAppPageList();
            },
            getMppAppPageList(query = {}) {
                this.loading = true;
                get(`/mpp/apppage/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.mppAppPageList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getMppAppPageById() {
                get(`/mpp/apppage/get`,{ id: this.currentMppAppPageId }).then((res) =>{
                    if(res.success){
                      this.mppAppPage = { ...this.mppAppPage, ...res.mppAppPage };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportMppAppPageList() {
                //this.btnLoading = true;
                exprotExcel(`/mpp/apppage/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/mpp/apppage/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/mpp/apppage/importData`,formData);
              this.refreshMppAppPageList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getMppAppPageList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getMppAppPageList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>